import { render } from "./Incidence_zones.vue?vue&type=template&id=6e3af29a"
import script from "./Incidence_zones.vue?vue&type=script&lang=js"
export * from "./Incidence_zones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__